import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import classNames from 'classnames';
import { FC } from 'react';
import { DateFormats, emptyDate } from 'src/constants/dateFormats';
import { formatDate } from 'src/utils/dateFormatter';

import classes from './DateTooltip.module.scss';

export interface DateTooltipProps {
  tooltipTitle?: string;
  icon?: IconDefinition;
  date?: string;
  className?: string;
}

const DateTooltip: FC<DateTooltipProps> = ({
  tooltipTitle,
  icon,
  date,
  className,
}) => {
  return (
    <div className={classNames(classes.Container, className)}>
      <Tooltip
        classes={{ tooltip: classes.Tooltip }}
        title={tooltipTitle}
        arrow
        placement="top"
        enterTouchDelay={0}
      >
        <div>
          <FontAwesomeIcon icon={icon} />
        </div>
      </Tooltip>
      <p>
        {date ? formatDate(date, DateFormats.TICKET_LIST_FORMAT) : emptyDate}
      </p>
    </div>
  );
};

export default DateTooltip;
